import { IdName } from 'interfaces/IdName';
import { StatusTypes } from 'constants/statusTypes';

export const formatPropertyStatus = (status: IdName | null | undefined) => {
  return status?.name && status?.name !== StatusTypes.Existing
    ? status?.name
    : null;
};
